import React, {Component} from 'react';
import {Redirect} from 'react-router';
import saganLogo from '../../images/sagan-logo.svg';
import {connect} from 'react-redux';
import Button from '../../components/button';
import TextField from '@material-ui/core/TextField';
import ComponentErrorBoundary from '../../components/component-error-boundary';
import {CONTEXT_ENABLED} from '../../config/features';
import {
  loginRequest,
} from './login.actions';


export class Login extends Component {
  constructor(props) {
    super(props);

    // Get session timeout message from sessionStorage
    const sessionTimeoutMessage = sessionStorage.getItem('sessionTimeoutMessage') || '';
    console.log('Session timeout message from storage:', sessionTimeoutMessage);

    this.state = {
      username: '',
      password: '',
      loginButtonStatus: true,
      loginButtonLabel: 'Log in',
      userIdError: '',
      passwordError: '',
      userIdErrorStatus: false,
      passwordErrorStatus: false,
      isRedirect: false,
      sessionTimeoutMessage: sessionTimeoutMessage,
    };
  };


  componentDidMount() {
    // Clear the session timeout message from sessionStorage after reading it
    if (this.state.sessionTimeoutMessage) {
      sessionStorage.removeItem('sessionTimeoutMessage');
    }
  }


  componentDidUpdate(prevProps) {
    if (this.state.username.length>1 && this.state.password.length >1 && this.state.loginButtonStatus) {
      this.setState({
        loginButtonStatus: false,
      });
    }


    if (this.props.authError !== prevProps.authError) {
      if (this.props.authError === '') {
        this.setState({
          userIdError: '',
          passwordError: '',
          userIdErrorStatus: false,
          passwordErrorStatus: false,
          isRedirect: false,
        });
      } else {
        this.setState({
          loginButtonLabel: 'Login',
          userIdError: 'Email Id is incorrect',
          passwordError: 'Password is incorrect',
          userIdErrorStatus: true,
          passwordErrorStatus: true,
          isRedirect: false,
        });
      }
    }
  }


  resetForm = () => {
    this.setState({
      userIdError: '',
      passwordError: '',
      loginButtonStatus: true,
      userIdErrorStatus: false,
      passwordErrorStatus: false,
    });
  };


  keyPressed=(event)=>{
    if (event.key === 'Enter' && !this.state.loginButtonStatus) {
      this.login();
      event.preventDefault();
      event.stopPropagation();
    }
  };


  setTxtFieldValue = (event, name) => {
    this.setState({
      [name]: event.target.value,
      userIdError: '',
      passwordError: '',
      userIdErrorStatus: false,
      passwordErrorStatus: false,
      sessionTimeoutMessage: '', // Clear timeout message when user starts typing
    });
    if (this.state.username.length>1 && this.state.password.length >1) {
      this.setState({loginButtonStatus: false});
    } else {
      this.setState({loginButtonStatus: true});
    }
  };

  login=()=> {
    const credentials={
      email: this.state.username,
      password: this.state.password,
    };


    this.setState({
      loginButtonLabel: 'Please wait...',
      isRedirect: true,
    }, ()=>{
      this.props.sendLoginRequest(credentials);
    });
  };

  render() {
    const {isAuthenticated, getContext, getRoleId} = this.props.auth;
    window.addEventListener('keydown', this.keyPressed);

    // console.log("isAuthenticated()",isAuthenticated(),'getContext()',getContext());

    if (isAuthenticated() && getContext() !== null && getRoleId() !== 1 && this.state.isRedirect ) {
      return (
        <Redirect to="/home" />
      );
    } else if (isAuthenticated() && getContext() === null && getRoleId() !== 1 && this.state.isRedirect ) {
      // #622: context disabled → skip the /context gate and land on /home.
      return (
        <Redirect to={CONTEXT_ENABLED ? "/context" : "/home"} />
      );
    } else if (isAuthenticated() && getContext() === null && getRoleId() === 1 && this.state.isRedirect ) {
      return (
        <Redirect to="/admin" />
      );
    } else {
      return (
        <div className="container">
          <div className="login-screen">
            <h1>SKOKIE</h1>
            <img src={saganLogo} width="200" height="200" align="center" alt="Skokie" />

            <div className="login-description">

              <ComponentErrorBoundary value="login username">
                <TextField
                  label="Email ID"
                  value={this.state.username}
                  fullWidth
                  id="userid"
                  inputProps={{'data-testid': 'login-email'}}
                  FormHelperTextProps={{'data-testid': 'login-error'}}
                  onChange={(e)=>this.setTxtFieldValue(e, 'username')}
                  error={this.state.userIdErrorStatus}
                  helperText={this.state.userIdError}
                />
              </ComponentErrorBoundary>

              <ComponentErrorBoundary value="login password">
                <TextField
                  label="Password"
                  type='password'
                  value={this.state.password}
                  fullWidth
                  name="password"
                  inputProps={{'data-testid': 'login-password'}}
                  onChange={(e)=>this.setTxtFieldValue(e, 'password')}
                  error={this.state.passwordErrorStatus}
                  helperText={this.state.passwordError}
                />
              </ComponentErrorBoundary>

            </div>
            <div className='btn-container'>
              <Button label={this.state.loginButtonLabel}
                disabled={this.state.loginButtonStatus}
                id="loginBtn"
                data-testid="login-submit"
                onClick={this.login.bind(this)}
                className='btn btn-action'
              />
            </div>

            {this.state.sessionTimeoutMessage && (
              <div data-testid="session-timeout-banner" style={{
                marginTop: '16px',
                padding: '12px',
                backgroundColor: '#fff3cd',
                border: '1px solid #ffc107',
                borderRadius: '4px',
                color: '#856404',
                fontSize: '14px',
                textAlign: 'center',
              }}>
                {this.state.sessionTimeoutMessage}
              </div>
            )}

          </div>
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    authError: state.loginReducer.authError,
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    sendLoginRequest: (credentials) => {
      dispatch(loginRequest(credentials));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
